var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "is-invalid": _vm.isInvalid } },
    [
      _c("multiselect", {
        attrs: {
          options: _vm.options,
          label: "name",
          "track-by": "name",
          "show-labels": false,
          multiple: _vm.multiple
        },
        on: { input: _vm.input },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(props) {
              return [_vm._v("\n      " + _vm._s(props.option.name) + "\n    ")]
            }
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }